/* eslint-disable import/no-unresolved */

import _ from 'lodash';
import { put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import API from 'types/api';
import createBaseRequest from 'utils/createBaseRequest';
import urlConstructor from 'utils/urlConstructor';
import apiActions from 'actions/api';
import { getVideoStream, getPrev, getNext } from 'selectors/player';

export function* loadMoreEpisodes(info, stream) {
  const { video_id: videoId } = stream;
  const seasonsState = yield select((state) => state.season);
  const prev = yield select(getPrev);
  const next = yield select(getNext);
  const seasons = _.filter(seasonsState, (season) => _.includes(info.season_list, season.id));
  const seasonIndex = _.findIndex(seasons, { episode_list: [videoId] });
  if (prev && !prev.title) {
    if (seasonIndex > 0) {
      const prevSeasonIndex = seasonIndex - 1;
      if (
        seasons[prevSeasonIndex].total > seasons[prevSeasonIndex].episode_list.length &&
        !seasons[prevSeasonIndex].isLoading
      ) {
        yield put(apiActions.getEpisodes(seasons[prevSeasonIndex].id));
      }
    }
  }
  if (next && !next.title) {
    const nextSeasonIndex = seasonIndex + 1;
    if (nextSeasonIndex < seasons.length) {
      if (
        seasons[nextSeasonIndex].total > seasons[nextSeasonIndex].episode_list.length &&
        !seasons[nextSeasonIndex].isLoading
      ) {
        yield put(apiActions.getEpisodes(seasons[nextSeasonIndex].id));
      }
    }
  }
}

export function* fetchMovieFromStream() {
  const stream = yield select(getVideoStream);
  if (stream && (stream.next || stream.prev)) {
    const info = yield select(
      (state) => state.movie[stream.root_video_id] || state.movie[stream.video_id]
    );
    if (!info) {
      yield put(apiActions.getVideoInfo(stream.video_id, { root_object: true }));
    } else if (
      !_.get(info, 'isLoading') &&
      !_.get(info, 'isError') &&
      (stream.prev || stream.next)
    ) {
      yield loadMoreEpisodes(info, stream);
    }
  }
}

export function* fetchNeighboringEpisodes() {
  const stream = yield select(getVideoStream);
  if (stream) {
    const info = yield select(
      (state) => state.movie[stream.root_video_id] || state.movie[stream.video_id]
    );
    if (!_.get(info, 'isLoading') && !_.get(info, 'isError') && (stream.prev || stream.next)) {
      yield loadMoreEpisodes(info, stream);
    }
  }
}

export default function*() {
  yield takeLatest(API.GET_STREAM, createBaseRequest(API.GET_STREAM, urlConstructor.getStream));
  yield takeLatest(
    API.GET_STREAM_VIRTUAL,
    createBaseRequest(API.GET_STREAM_VIRTUAL, urlConstructor.getStreamVirtual)
  );
  yield takeLatest(
    API.GET_STREAM_EXTERNAL,
    createBaseRequest(API.GET_STREAM_EXTERNAL, urlConstructor.getStream)
  );
  yield takeLatest(
    API.GET_TRANSLATE,
    createBaseRequest(API.GET_TRANSLATE, urlConstructor.getTranslate)
  );
  yield takeLatest(
    API.GET_VIDEO_INFO,
    createBaseRequest(API.GET_VIDEO_INFO, urlConstructor.getVideoInfo)
  );
  yield takeLatest(
    API.GET_CONFIGURATION,
    createBaseRequest(API.GET_CONFIGURATION, urlConstructor.getConfiguration)
  );
  yield takeLatest(
    API.GET_PAYMENTS_SYSTEM,
    createBaseRequest(API.GET_PAYMENTS_SYSTEM, urlConstructor.getPaymentsSystem)
  );
  yield takeEvery(
    API.GET_EPISODES,
    createBaseRequest(API.GET_EPISODES, urlConstructor.getEpisodes)
  );
  yield takeLatest(API.GET_USER, createBaseRequest(API.GET_USER, urlConstructor.getUser));
  yield takeLatest(
    API.GET_SUBSCRIPTION_INFO,
    createBaseRequest(API.GET_SUBSCRIPTION_INFO, urlConstructor.getSubscriptionInfo)
  );
  yield takeLatest(
    API.GET_VIDEO_COLLECTION,
    createBaseRequest(API.GET_VIDEO_COLLECTION, urlConstructor.getVideoCollection)
  );
  yield takeLatest(
    API.GET_EPG_TIME,
    createBaseRequest(API.GET_EPG_TIME, urlConstructor.getEpgTime)
  );
  yield takeLatest(
    API.GET_EPG_CURRENT,
    createBaseRequest(API.GET_EPG_CURRENT, urlConstructor.getEpgCurrent)
  );
  yield takeEvery(API.GET_EPG, createBaseRequest(API.GET_EPG, urlConstructor.getEpg));
  yield takeLatest(
    API.GET_CHANNELS,
    createBaseRequest(API.GET_CHANNELS, urlConstructor.getChannels)
  );
  yield takeLatest(API.POST_AUTH, createBaseRequest(API.POST_AUTH, urlConstructor.postAuth));
  yield takeLatest(API.POST_LOGOUT, createBaseRequest(API.POST_LOGOUT, urlConstructor.postLogout));
  yield takeLatest(
    API.POST_REGISTRATION,
    createBaseRequest(API.POST_REGISTRATION, urlConstructor.postRegistration)
  );
  yield takeLatest(
    API.POST_RESTORE,
    createBaseRequest(API.POST_RESTORE, urlConstructor.postRestore)
  );
  yield takeLatest(API.GET_VIDEO_INFO_SUCCESS, fetchNeighboringEpisodes);
  yield takeLatest(API.GET_STREAM_SUCCESS, fetchMovieFromStream);
  yield takeLatest(
    API.GET_USER_HISTORY,
    createBaseRequest(API.GET_USER_HISTORY, urlConstructor.getUserHistory)
  );
  yield takeLatest(
    API.POST_CARD_ENCRYPT,
    createBaseRequest(API.POST_CARD_ENCRYPT, urlConstructor.postCardEncrypt)
  );
}
